import { render, staticRenderFns } from "./GlobalLoader.vue?vue&type=template&id=40c9cb52&scoped=true&"
import script from "./GlobalLoader.vue?vue&type=script&lang=ts&"
export * from "./GlobalLoader.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalLoader.vue?vue&type=style&index=0&id=40c9cb52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c9cb52",
  null
  
)

export default component.exports